



















































































































import {
  computed,
  defineComponent,
  onBeforeMount,
  reactive,
  SetupContext,
  watch,
} from '@vue/composition-api';
import { ColorizableArea } from '@/models/entities/Location';
import { IFieldFilter } from '@/models/filters/Filters';
import { Color } from '@/models/entities/Color';
import ColorsPaginatedAutocomplete from '@/components/entities/colors/ColorsPaginatedAutocomplete.vue';
import { ColorGroup } from '@/models/entities/ColorGroup';

const { DropdownFilter } = require('@/models/filters/Filters');

interface Props {
  areas: ColorizableArea[];
  colorFilter: IFieldFilter;
  id: number;
  addAreaToLocation: (colorizableArea: ColorizableArea) => {};
  colorGroups: ColorGroup[];
}

interface State {
  newColorizableArea: ColorizableArea;
}

const Component = defineComponent({
  name: 'ColorizableAreasSimpleTable',

  components: { ColorsPaginatedAutocomplete },
  props: {
    areas: Array,
    colorFilter: Object,
    id: Number,
    addAreaToLocation: Function,
    colorGroups: Array,
  },

  setup(props: Props, { root: { $store } }: SetupContext) {
    const colorizableAreas = props.areas;
    const entityId = props.id;
    const colorGroups = props.colorGroups;
    const colorFilter = props.colorFilter;

    const state = reactive({
      newColorizableArea: new ColorizableArea({}),
    }) as State;

    watch(
      props,
      (newProps: Props) => {
        Object.assign(colorizableAreas, newProps.areas);
        Object.assign(colorGroups, newProps.colorGroups);
        Object.assign(entityId, newProps.id);
        Object.assign(colorFilter, newProps.colorFilter);
      },
      { immediate: false, deep: true },
    );

    function selectColorizableArea(value: ColorizableArea, oldArea: ColorizableArea) {
      if (!oldArea) {
        const newArea = new ColorizableArea({ ...value });
        newArea.colors = state.newColorizableArea.colors;
        state.newColorizableArea = newArea;
      } else if (value.id !== oldArea.id) {
        value.colors = oldArea.colors;
        oldArea.colors = [];
      }
    }

    function deleteColorizableArea(colorizableArea: ColorizableArea) {
      colorizableArea.colors = [];
    }

    function addColorizableArea() {
      props.addAreaToLocation(state.newColorizableArea);
      state.newColorizableArea = new ColorizableArea({});
    }

    function editColor(val: (number | Color)[], colorizableArea: ColorizableArea) {
      let result: Color[] = [];
      val.forEach(item => {
        if (typeof item === 'number') {
          const color = colorizableArea.colors.find(color => color.id === item);
          if (color !== undefined) result.push(color);
        } else result.push(item);
      });
      colorizableArea.colors = result;
    }

    return {
      state,
      DropdownFilter,
      colorizableAreas,
      entityId,
      selectColorizableArea,
      deleteColorizableArea,
      addColorizableArea,
      editColor,
    };
  },
});
export default Component;
